import { lazy } from 'react';

export const publicRoutes = [
  {
    path: '/login',
    exact: true,
    element: lazy(() => import('./pages/Login'))
  }
];

export const protectedRoutes = [
  {
    path: '/user',
    exact: true,
    element: lazy(() => import('./pages/Users'))
  },
  {
    path: '/',
    exact: true,
    element: lazy(() => import('./pages/Organization'))
  },
  {
    path: '/create',
    exact: true,
    element: lazy(() => import('./pages/SingleOrganization'))
  },
  {
    path: '/edit/:id',
    exact: true,
    element: lazy(() => import('./pages/SingleOrganization'))
  },
  {
    path: '/user/edituser/:id',
    exact: true,
    element: lazy(() => import('./pages/SingleUser'))
  },
  {
    path: '/emissions',
    exact: true,
    element: lazy(() => import('./pages/EmissionsMaster'))
  },
  {
    path: '/emissions/create',
    exact: true,
    element: lazy(() => import('./pages/SingleEmission'))
  },
  {
    path: '/emissions/edit/:id',
    exact: true,
    element: lazy(() => import('./pages/SingleEmission'))
  },
  {
    path: '/sectors',
    exact: true,
    element: lazy(() => import('./pages/Sectors'))
  },
  {
    path: '/countries',
    exact: true,
    element: lazy(() => import('./pages/Countries'))
  },
  {
    path: '/assetclasses',
    exact: true,
    element: lazy(() => import('./pages/AssetClasses'))
  },
  {
    path: '/assetclasses/create',
    exact: true,
    element: lazy(() => import('./pages/SingleAsset'))
  },
  {
    path: '/assetclasses/edit/:id',
    exact: true,
    element: lazy(() => import('./pages/SingleAsset'))
  },
  {
    path: '/counterparties',
    exact: true,
    element: lazy(() => import('./pages/CounterParties'))
  },
  {
    path: '/counterparties/create',
    exact: true,
    element: lazy(() => import('./pages/SingleCounterParty'))
  },
  {
    path: '/counterparties/edit/:id',
    exact: true,
    element: lazy(() => import('./pages/SingleCounterParty'))
  },
  {
    path: '/climaterisk',
    exact: true,
    element: lazy(() => import('./pages/ClimateRisk'))
  },
  {
    path: '/climaterisk/create',
    exact: true,
    element: lazy(() => import('./pages/SingleClimateRisk'))
  },
  {
    path: '/climaterisk/edit/:id',
    exact: true,
    element: lazy(() => import('./pages/SingleClimateRisk'))
  },
  {
    path: '/reports',
    exact: true,
    element: lazy(() => import('./pages/Reports'))
  },
  {
    path: '/reports/create',
    exact: true,
    element: lazy(() => import('./pages/SingleReports'))
  },
  {
    path: '/reports/edit/:id',
    exact: true,
    element: lazy(() => import('./pages/SingleReports'))
  },


]